import { configureStore } from "@reduxjs/toolkit";
import structureReducer from "./slice/structureSlice";
import overlayReducer from "./slice/overlaySlice";
import statusReducer from "./slice/statusSlice";
import outletReducer from "./slice/outletSlice";
import generatorReducer from "./slice/generatorSlice"
import metaReducer from "./slice/metaSlice";
import endpointReducer from "./slice/endpointSlice";

const store = configureStore({
  reducer: {
    structure: structureReducer,
    overlay: overlayReducer,
    status: statusReducer,
    outlet: outletReducer,
    generator: generatorReducer,
    meta: metaReducer,
    endpoint: endpointReducer
  },
});

export default store;
